import { render, staticRenderFns } from "./ListaAreaMonitoradaSocioambiental.vue?vue&type=template&id=d5b73588&scoped=true&lang=pug"
import script from "./ListaAreaMonitoradaSocioambiental.vue?vue&type=script&lang=js"
export * from "./ListaAreaMonitoradaSocioambiental.vue?vue&type=script&lang=js"
import style0 from "./ListaAreaMonitoradaSocioambiental.vue?vue&type=style&index=0&id=d5b73588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b73588",
  null
  
)

export default component.exports